import { FunctionComponent } from 'react';

import { DisplayIconProps } from './DisplayIconProps';
import { ReactComponent as DefaultConversationIcon } from './svgs/convo/icon-convo-default.svg';
import { ReactComponent as InversedConversationIcon } from './svgs/convo/icon-convo-inverse.svg';

export const ConversationIcon: FunctionComponent<DisplayIconProps> = ({
  isInverse,
}) => (isInverse ? <InversedConversationIcon /> : <DefaultConversationIcon />);
